var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.linkProperties.is,{tag:"component",class:{ 'router-link': _vm.linkProperties.is === 'router-link' },attrs:{"to":_vm.linkProperties.to,"href":_vm.linkProperties.href,"target":_vm.linkProperties.target,"rel":_vm.linkProperties.rel,"false-link":_vm.linkProperties.falseLink}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }